import React from "react";
import { useTranslation } from "react-i18next";

import { db } from "astrid-firebase";
import useDocumentDataOnce from "astrid-firestore/src/hooks/useDocumentDataOnce";

import FormSelect from "../../../forms/components/FormSelect/FormSelect";

import useTeamPriceOptions from "../../hooks/useTeamPriceOptions";

export default function TeamPriceSelect({ role, user, production, agreement, agreementId, ...props }) {
	const { t } = useTranslation();

	const [fetchedAgreement, agreementLoading, agreementError] = useDocumentDataOnce(
		!agreement && agreementId && db.collection("agreements").doc(agreementId),
	);

	// The fetched agreement lags one render behind agreementId. Until the right one has loaded, offer no options,
	// or FormSelect auto-selects a default price from the previous agreement (or the fallback price list)
	const agreementPending = agreementLoading || (!!fetchedAgreement && fetchedAgreement.id !== agreementId);

	const [options, optionsLoading, optionsError] = useTeamPriceOptions({
		role,
		user,
		agreement: agreement || (agreementPending ? undefined : fetchedAgreement),
		language: production.language,
		producerId: production.producer,
	});

	const loading = agreementLoading || optionsLoading;
	const error = agreementError || optionsError;

	return (
		<FormSelect
			label={t("price", "Price")}
			options={agreementPending ? [] : options}
			loading={loading || agreementPending}
			error={error?.message || error}
			search
			deburr
			{...props}
		/>
	);
}
